// default
export const USER = 'user';
export const USER_SLICE_NAME = `${USER}Slice`;

// action
export const GET_USERS = `${USER}/getUsers`;
export const GET_USER_METAS = `${USER}/getUserMetas`;
export const GET_USER_DETAIL = `${USER}/getUserDetail`;
export const CREATE_USER = `${USER}/createUser`;
export const CREATE_USERS_WORKER = `${USER}/createUsersWorker`;
export const UPDATE_USER = `${USER}/updateUser`;
export const DELETE_USER = `${USER}/deleteUser`;
export const DELETE_USER_DATA = `${USER}/deleteUserData`;
export const GET_USER_DOWNLOAD = `${USER}/getUserDownload`;
export const UPDATE_USER_MOBILE = `${USER}/updateUserMobile`;

// actions
export const actions = {
  GET_USERS,
  GET_USER_METAS,
  GET_USER_DETAIL,
  CREATE_USER,
  CREATE_USERS_WORKER,
  UPDATE_USER,
  DELETE_USER,
  DELETE_USER_DATA,
  GET_USER_DOWNLOAD,
  UPDATE_USER_MOBILE
};
